import { Box, Container, Heading, SimpleGrid, useColorModeValue } from '@chakra-ui/react';
import Link from 'next/link';
import React from 'react';

import { FrontendLayout } from '../../components/FrontendLayout';
import ProductImage from '../../components/home/ProductImage';
import { getProducts, Products } from '../../lib/rails_api/getProducts';

type PropsType = {
  products: Products;
};

function IndexPage({ products }: PropsType): JSX.Element {
  const nonDonationProduct = products.subscription_products.filter(
    (product) => product.price_cents !== 0
  );

  const cardColorMode = useColorModeValue('white', 'gray.900');

  return (
    <FrontendLayout>
      <Container maxW="container.xl" pb="10">
        <Heading mt="8" as="h1" size="4xl" textAlign="center">
          Subscribe
        </Heading>
        <SimpleGrid mt="16" minChildWidth="320px" spacing="40px" autoRows="1fr">
          {nonDonationProduct.map((product) => (
            <Link key={product.id} href={`/subscribe/${product.id}`}>
              <a>
                <Box
                  bg={cardColorMode}
                  maxW="360px"
                  boxShadow={'2xl'}
                  rounded={'md'}
                  p="8"
                  height="100%"
                  mx="auto"
                >
                  <ProductImage imageUrl={product.image_url} />
                  <Box textAlign="center" mt="2">
                    <Heading as="h2" size="lg">
                      {product.display_name}
                    </Heading>
                    <Heading as="h3" size="md">
                      ${product.price_cents / 100} / Year
                    </Heading>
                    <Box mt="2">{product.description}</Box>
                  </Box>
                </Box>
              </a>
            </Link>
          ))}
        </SimpleGrid>
      </Container>
    </FrontendLayout>
  );
}

export const getServerSideProps = async (): Promise<{ props: PropsType }> => {
  const products = await getProducts();
  return { props: { products } };
};

export default IndexPage;
